<template>
  <div class="text-xs font-sans font-light p-1">
    <slot></slot>
  </div>
</template>
